define(function () {
    var sections = ['politics', 'world', 'business', 'commentisfree'];

    function getSection(section) {
        section = section.toLowerCase();
        return /news/.test(section) || sections.indexOf(section) !== -1 ? 'news' : 'defaults';
    }

    return getSection;
});



//////////////////
// WEBPACK FOOTER
// ./static/src/javascripts-legacy/projects/commercial/modules/third-party-tags/outbrain-sections.js
// module id = 779
// module chunks = 1